/**
 * The ID for the search toolbar.
 *
 * @since 0.1.0
 */
export const TOOLBAR_ID = 'search';

/**
 * The group ID for markers.
 *
 * @since 0.1.0
 */
export const MARKER_ID = 'match';

/**
 * The group ID for an active marker.
 *
 * @since 0.1.0
 */
export const ACTIVE_MARKER_ID = 'active-match';

/**
 * The throttle duration for applying the input result to the range.
 *
 * @since 0.1.0
 */
export const SEARCH_THROTTLE_DURATION = 10;

/**
 * The delay time until jumping to the next match after replace.
 *
 * @since 0.1.0
 */
export const JUMP_DELAY_AFTER_REPLACE = 20;
